import { GENERAL_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setError = dispatch => error => dispatch({
  type: ACTION_TYPE.SET_ERROR,
  payload: {
    error
  }
});
const setShowDiscardKeywordGenerationModal = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SHOW_DISCARD_KEYWORD_GENERATION_MODAL,
  payload: {
    showDiscardKeywordGenerationModal: val
  }
});
const setShowDiscardKeywordsModal = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SHOW_DISCARD_KEYWORDS_MODAL,
  payload: {
    showDiscardKeywordsModal: val
  }
});
const setShowUpdateAutotaggingModal = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SHOW_UPDATE_AUTOTAGGING_MODAL,
  payload: {
    showUpdateAutotaggingModal: val
  }
});
const setUpdateAutotaggingModalSeenCount = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT,
  payload: {
    updateAutotaggingModalSeenCount: val
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setError,
  setShowDiscardKeywordGenerationModal,
  setShowDiscardKeywordsModal,
  setShowUpdateAutotaggingModal,
  setUpdateAutotaggingModalSeenCount,
  setMultiple
};